// src/data/grammar/m4/index.js

import ToBe  from './ToBe.json'; 
import PresentSimple from './presentsimple.json'; 
import presentcontinous from './presentcontinuous.json';// Los JSON suelen estar bien así
import  negatives  from './negatives.json';    
import  questions  from './questions.json';  
import  Stateverbs  from './Stateverbs.json';  
import  feelings  from './feelings.json';           // ✅ Agrega llaves si es export const
import intensifiers  from './intensifiers.json';   
import  phrasalVerbs  from './phrasal verbs.json';  // ✅ (Cuidado con el espacio en el nombre)
import  prepositions from './prepositions.json';   // ✅
import  simplevscontinuous  from './simplevscontinuous.json'; 
import time from './time.json';           
import Health from './health.json';  
import weather from './weather.json';  
import comparatives from './comparative.json';  
import superlatives from './superlative.json';  
import WhichvsWhat from './whichvswhat.json';  
// ✅ CORRECCIÓN: Usar el spread operator
export const GRAMMAR_M4 = [
  ...ToBe,
  ...PresentSimple,
 ...presentcontinous,
   ...negatives,
    ...questions,
  ...Stateverbs,
  ...feelings,
  ...intensifiers,
  ...phrasalVerbs,
  ...prepositions,
  ...simplevscontinuous,
  ...time,
  ...Health,
  ...weather,
  ...comparatives,
  ...superlatives,
  ...WhichvsWhat,
];